import React, { memo, useCallback, useState } from 'react';

import Image from '@atlaskit/image';

/**
 * Moving these components into a /raw folder is purely to facilitate unit testing
 */

type ImageFromUrlProps = {
	alt?: string;
	fallback?: React.ReactNode;
	src?: string;
	testId?: string;
};

// Exported for unit test purposes
export function ImageFromUrlRaw({ src, alt, fallback, testId }: ImageFromUrlProps) {
	const [hasError, setHasError] = useState(false);

	const handleOnError = useCallback(() => {
		setHasError(true);
	}, [setHasError]);

	if (!src || hasError) {
		return fallback;
	}

	return <Image src={src} alt={alt} onError={handleOnError} testId={testId} />;
}

export const ImageFromUrlMemoed = memo(ImageFromUrlRaw);
